<template>
  <VDialog v-model="isShowModal" max-width="600" persistent>
    <VToolbar color="primary" density="compact">
      <VToolbarTitle>
        <!-- <VIcon icon="mdi-plus" class="mr-2" /> -->
        Add Question
      </VToolbarTitle>
      <VSpacer />
      <VBtn icon="mdi-close" variant="text" @click="handleCancel" :disabled="isLoading" />
    </VToolbar>
    <VCard>
      <VCardItem>
        <VForm v-model="formValid" @submit.prevent class="mb-3 my-2">
          <VRow>
            <VCol cols="12">
              <VCombobox
                label="Question"
                variant="outlined"
                v-model="form.value"
                :items="questionSearchOptions"
                :rules="formRules.value"
                :hide-no-data="true"
                :loading="isLoadingQuestions"
                :disabled="isLoading"
                autofocus
                :maxlength="255"
                counter
              ></VCombobox>
            </VCol>
            <VCol v-if="type === 'Main Category'">
              <VSelect
                label="Type"
                prepend-inner-icon="mdi-account-outline"
                variant="outlined"
                color="primary"
                name="fieldType"
                v-model="form.fieldType"
                :rules="formRules.fieldType"
                :disabled="isLoading"
                :items="fieldTypeOptions"
              />
            </VCol>
            <VCol cols="12" v-if="category.value">
              <VChip variant="outlined" color="primary" prepend-icon="mdi-folder">
                Category: {{ category.value }}
              </VChip>
            </VCol>
            <VCol cols="12">
              <VBtn :loading="isLoading" class="mb-2" type="submit" color="primary" block flat @click="handleSubmit()">
                Add
              </VBtn>
              <VBtn :disabled="isLoading" color="grey-100" block flat @click="handleCancel()">Cancel</VBtn>
            </VCol>
          </VRow>
        </VForm>
      </VCardItem>
    </VCard>
  </VDialog>
</template>

<script>
import { mapActions } from 'vuex';
// Service
import requestsService from '@/services/requests-service/requests.service';
// Text
import { successAddQuestionText, errorAddQuestionText } from '@/text/snackbarsText';
export default {
  name: 'CreateCategoryModal',

  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    category: {
      type: Object
    },
    type: {
      type: String
    },
    requestId: {
      type: String
    }
  },

  emits: ['update:modelValue', 'saved', 'close'],

  watch: {
    category: {
      handler() {
        this.form.value = '';
        this.form.fieldType = 'Text';
      },
      immediate: true,
      deep: true
    },
    modelValue: {
      handler() {
        if (this.modelValue) {
          this.getQuestions();
        }
      },
      immediate: true,
      deep: true
    }
  },

  data() {
    return {
      isLoading: false,
      isLoadingQuestions: false,
      questionSearchOptions: [],
      fieldTypeOptions: ['Text', 'Attachment'],
      form: {
        value: '',
        fieldType: 'Text'
      },
      formValid: false,
      formRules: {
        value: [(v) => !!v || 'Question required'],
        fieldType: [(v) => !!v || 'Question type required']
      }
    };
  },

  computed: {
    isShowModal() {
      return this.modelValue;
    }
  },

  methods: {
    ...mapActions('main', ['showSnackbar', 'startLoading', 'stopLoading']),
    async getQuestions() {
      try {
        const categoryData = {
          type: this.type,
          requestId: this.requestId,
          categoryId: this.category.categoryId
        };
        const { questions } = await requestsService.searchQuestions(categoryData);
        this.questionSearchOptions = questions ?? [];
      } catch (err) {
        console.error(err);
      }
    },
    async handleSubmit() {
      if (this.formValid === true) {
        this.isLoading = true;
        try {
          const questionData = {
            categoryId: this.category.categoryId,
            type: this.type,
            requestId: this.requestId,
            question: {
              value: this.form.value,
              fieldType: this.form.fieldType
            }
          };
          const { question } = await requestsService.addNewQuestion(questionData);
          this.showSnackbar({ text: successAddQuestionText, color: 'green' });
          this.handleSuccess(this.category.categoryId, question);
        } catch (err) {
          console.error(err);
          this.showSnackbar({ text: errorAddQuestionText, color: 'red' });
        } finally {
          this.isLoading = false;
        }
      }
    },

    handleSuccess(categoryId, createdQuestion) {
      this.$emit('saved', { categoryId: categoryId, createdQuestion: createdQuestion });
      this.handleCancel();
    },

    handleCancel() {
      this.$emit('update:modelValue', false);
      this.$emit('close');
      this.resetForm();
    },

    resetForm() {
      this.form = {
        value: '',
        fieldType: 'Text'
      };
    }
  }
};
</script>
